// extracted by mini-css-extract-plugin
export default {"bulkLoadCulturePlatesUnknownError":"bulkLoadCulturePlatesUnknownError-D9oMz"};